/* jscs:disable maximumLineLength */
define('features/overlayGameLauncher/composition',[], function () {
    return {

        adventureTwo: {
            module: 'adventureTwo/adventureTwoObservableData'
        },

        adventureTwoDebugCommands: {
            module: 'adventureTwo/debugCommands/debugCommandsInit',
            args: [
                'PlatformCmd:thenewadventureprototype/addGems:common',
                'PlatformCmd:thenewadventureprototype/addXp:common',
                '@adventureTwo'
            ],
            extras: [{
                subscribe: {
                    onSessionPlayer: 'init'
                }
            }]
        },

        AdventureTwoModel: {
            module: 'adventureTwo/AdventureTwoModel',
            args: [
                '@AdventureTwoSummaryModel',
                '@AdventureTwoShopModel',
                '@adventureTwo'
            ]
        },

        AdventureTwoSummaryModel: {
            module: 'adventureTwo/summary/SummaryModel',
            init: 'partial'
        },

        adventureTwoSummarySubscriptionHandlers: {
            module: 'adventureTwo/summary/subscriptionHandlers',
            args: [
                '@adventureTwo'
            ]
        },

        adventureTwoSummaryInit: {
            module: 'adventureTwo/summary/summaryInit',
            args: [
                '@Query',
                '@cometd',
                '@adventureTwoSummarySubscriptionHandlers',
                '@adventureTwo'
            ],
            extras: [{
                subscribe: {
                    onSessionPlayer: 'init'
                }
            }]
        },

        adventureTwoInventoryInit: {
            module: 'adventureTwo/inventory/inventoryInit',
            args: [
                '@adventurers',
                '@adventureTwo'
            ],
            extras: [{
                subscribe: {
                    onSessionPlayer: 'init'
                }
            }]
        },

        AdventureTwoShopModel: {
            module: 'adventureTwo/shop/ShopModel',
            init: 'partial',
            args: [
                '@AdventureTwoShopItemModel'
            ]
        },

        AdventureTwoShopItemModel: {
            module: 'adventureTwo/shop/ShopItemModel',
            init: 'partial',
            args: [
                'PlatformCmd:thenewadventureprototype/buyShopItem:common'
            ]
        },

        AdventureStaticData: {
            module: 'adventureTwo/adventureStaticData',
            init: 'partial',
            args: []
        },

        shopInit: {
            module: 'adventureTwo/shop/shopInit',
            args: [
                '@Query',
                '@adventureTwo'
            ],
            extras: [{
                subscribe: {
                    onSessionPlayer: 'init'
                }
            }]
        },

        statViewModelInjections: {
            module: 'statViewModelInjections',
            args: [
                '@GemsViewModel',
                '@XPViewModel',
                '@XPMilestonesViewModel',
                '@XPRandomMilestonesViewModel',
                '@ShopViewModel',
                '@adventureOverride'
            ]
        },

        overlayGame2: {
            module: 'overlayGame2',
            args: [
                '@navigation',
                '@statViewModelInjections',
                '@XPRandomMilestonesViewModel',
                '@ShopViewModel'
            ]
        },

        XPViewModel: {
            module: 'stats/xp/xpViewModel',
            init: 'partial',
            args: [
                '@AdventureTwoModel',
                '@AdventureStaticData'
            ]
        },

        XPMilestonesViewModel: {
            module: 'stats/xpMilestones/xpMilestonesViewModel',
            init: 'partial',
            args: [
                '@AdventureTwoModel',
                '@AdventureStaticData'
            ]
        },

        XPRandomMilestonesViewModel: {
            module: 'stats/xpRandomMilestones/xpRandomMilestonesViewModel',
            init: 'partial',
            args: [
                '@AdventureTwoModel',
                '@AdventureStaticData'
            ]
        },

        GemsViewModel: {
            module: 'stats/gems/gemsViewModel',
            init: 'partial',
            args: [
                '@AdventureTwoModel',
                '@itemManager'
            ]
        },

        ShopViewModel: {
            module: 'stats/shop/shopViewModel',
            init: 'partial',
            args: [
                '@AdventureTwoModel'
            ]
        }
    };
});

